import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const techdocsFeedbackPlugin = createPlugin({
  id: 'techdocs-feedback',
  routes: {
    root: rootRouteRef,
  },
});

export const TechDocsFeedbackPage = techdocsFeedbackPlugin.provide(
  createRoutableExtension({
    name: 'TechDocsFeedbackPage',
    component: () =>
      import('./components/TechDocsFeedbackPage').then(
        m => m.TechDocsFeedbackPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
